import { CategoriesValues, MicroMClient } from "@mcurros2/microm";
import { IconCategory } from "@tabler/icons-react";

export const GruposProductoIcon = IconCategory;
export const GruposProductoHelpText = "* Ingrese aquí los grupos de producto";

export class catGruposProducto extends CategoriesValues {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, parentKeys);
        this.def.columns.c_category_id.value = "GruposProducto";
        this.def.columns.c_category_id.defaultValue = "GruposProducto";
        this.Title = "Grupos de Producto";
        this.HelpText = GruposProductoHelpText;
        this.Icon = GruposProductoIcon;
    }
}